import { InputTravellerParameter, TravellerFieldEnum } from '@websky/graphql';
import { isDateFieldType, isNameFieldType } from '../PassengerForm/utils';
import { formatInvalidPassengerDate } from '../Passenger/utils';
import { GraphQLError } from 'graphql';

export const getDifferentPassengerValues = (
	originalValues: InputTravellerParameter[],
	changeValues: InputTravellerParameter[]
) => {
	const originalValueMap = new Map<TravellerFieldEnum, string>(
		originalValues.map(value => [value.type, value.value])
	);

	const editableValueMap = new Map<TravellerFieldEnum, InputTravellerParameter>();

	changeValues.forEach(value => {
		if (!originalValueMap.has(value.type)) {
			return;
		}

		let originalValue = originalValueMap.get(value.type);
		let changeValue = value.value;

		if (isNameFieldType(value.type)) {
			if (!originalValue) {
				originalValue = '';
			}

			if (!changeValue) {
				changeValue = '';
			}
		} else if (isDateFieldType(value.type)) {
			originalValue = formatInvalidPassengerDate(value.type, originalValue);
		}

		if (originalValue !== changeValue) {
			editableValueMap.set(value.type, value);
		}
	});

	return editableValueMap;
};

export const getIsOutdatedRequest = (requestError: GraphQLError) => {
	if (!requestError) {
		return false;
	}
	const message = typeof requestError === 'string' ? requestError : requestError?.message;

	return message?.includes('This operation is not available') || message?.includes('Order state has been changed');
};
